import { getPublicProductBundlesWithQuantities } from 'pricing-pages-api/bundles/ProductBundlesWithQuantitiesApi';
import { productConfigurationsToBundleProducts } from 'pricing-pages-lib/utils/productConfigUtils';
import { fetchBundlesApiCompleted, fetchBundlesApiFailed, fetchBundlesApiStarted } from '../actions/PlanBuilderActions';
import { PLAN_BUILDER_INITIALIZATION_COMPLETE, PLAN_BUILDER_PRODUCT_LEVEL_FOR_PRODUCT_LINE_UPDATED } from '../actions/constants/ActionTypes';
import { planBuilderCountryCodeSelector, planBuilderProductConfigurationsSelector } from '../selectors/PlanBuilderSelectors';
import { productDataSelector } from '../selectors/SelectorUtils';
import { Metrics } from '../utils/metrics';

/**
 * Calls MonBE's bundles API after certain actions have updated productConfigurations
 * the bundles API is responsible for turning, e.g. 5 Starter hubs -> 1 Suite Starter bundle
 *
 * It's not necessary to call the bundles API on _every_ update to productConfigurations,
 * only on page load and when a new product gets added or a product level gets updated
 */
export const bundlesApiMiddleware = store => next => action => {
  if (action.type === PLAN_BUILDER_INITIALIZATION_COMPLETE || action.type === PLAN_BUILDER_PRODUCT_LEVEL_FOR_PRODUCT_LINE_UPDATED) {
    // Commit the previous action's payload to state so we can access
    // the updated productConfigurations below
    next(action);

    // Apply the loading state
    store.dispatch(fetchBundlesApiStarted());
    const state = store.getState();
    const productConfigurations = planBuilderProductConfigurationsSelector(state);
    const countryCode = planBuilderCountryCodeSelector(state);
    const productData = productDataSelector(state);
    const bundleProducts = productConfigurationsToBundleProducts({
      productData
    }, {
      productConfigurations
    });
    getPublicProductBundlesWithQuantities({
      countryCode,
      products: bundleProducts
    }).then(newBundleProducts => {
      store.dispatch(fetchBundlesApiCompleted({
        productData,
        bundleProducts: newBundleProducts
      }));
      Metrics.counter('fetch-bundles-api-succeeded', {
        countryCode: countryCode.toString()
      }).increment();
    }).catch(() => {
      store.dispatch(fetchBundlesApiFailed());
      Metrics.counter('fetch-bundles-api-failed', {
        countryCode: countryCode.toString(),
        bundleProducts: JSON.stringify(bundleProducts)
      }).increment();
    });
    return;
  }
  return next(action);
};